import { SubmitRequestDialog } from 'components/requests/dialogs/SubmitRequestDialog';
import { type PayerRequestActionDialogProps } from 'services/interfaces';

const Title = 'Update Request Details';

export const UpdateRequestDetailsDialog = ({
    onClose,
    payerId,
    requestDetails,
}: PayerRequestActionDialogProps) => (
    <SubmitRequestDialog
        title={Title}
        isOpen
        payerId={payerId}
        onClose={onClose}
        requestDetails={requestDetails}
    />
);

UpdateRequestDetailsDialog.Title = Title;
